import Handlebars from 'handlebars';
import { IconChevronUp } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import androidAppLogo from '../../assets/images/android-app-logo.png';
import chromeIcon from '../../assets/images/chrome-icon.png';
import iosAppLogo from '../../assets/images/ios-app-logo.png';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import './PushNotificationPreviewStyles.css';

const PushNotificationPreview = ({
  pushNotification,
  platform,
}) => {
  const [error, setError] = useState();
  const fetch = useFetch();
  const [product, setProduct] = useState();
  const { domain } = useSelector((state) => state.domain);
  const isRecommender = product && pushNotification.type === 'recommender';

  useEffect(() => {
    fetch(`/api/admin/accounts/${domain.accountId}/domains/${domain.id}/products?from=0&size=1`)
      .then(({ products }) => setProduct(products[0]))
      .catch(setError);
  }, [domain.accountId, domain.id, fetch]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  const content = pushNotification.content[platform];

  const resolveHandlebars = (template) => {
    if (!template) return template;
    try {
      const compiled = Handlebars.compile(template);
      return compiled({ product });
    } catch {
      return template;
    }
  };

  const getNotificationIcon = () => {
    if (!content.iconUrl) return;
    const url = resolveHandlebars(content.iconUrl);
    if (!url) return;
    return <div style={{ backgroundImage: `url(${url})` }} className="notification-icon"></div>;
  };

  const WebNotification = () => (
    <div className="web-notification">
      <div className="web-notification-main">
        <div className="web-notification-icon">
          <img src={chromeIcon} alt="Chrome" className="web-notification-chrome-icon" />
        </div>

        <div className="web-notification-body">
          <div className="web-notification-content">
            <div className="web-notification-text">
              <h3 className="web-notification-title">{resolveHandlebars(content.subject)}</h3>
              <p className="web-notification-message">{resolveHandlebars(content.body)}</p>
            </div>

            <div className="web-notification-meta">
              <span className="web-notification-time">now</span>
              {getNotificationIcon()}
            </div>
          </div>

          <div className="web-notification-additional">
            {!isRecommender && content.imageUrl && (
              <div
                style={{ backgroundImage: `url(${resolveHandlebars(content.imageUrl)})` }}
                className="web-notification-image"
              ></div>
            )}
            {!isRecommender && content.btnText && (
              <div className="web-notification-actions">
                <button className="web-notification-options-button">{resolveHandlebars(content.btnText)}</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  const AndroidNotification = () => (
    <div className="web-notification android-notification">
      <div className="web-notification-main">
        <div className="web-notification-icon">
          <img src={androidAppLogo} alt="App logo" className="web-notification-chrome-icon" />
        </div>

        <div className="web-notification-body">
          <div className="web-notification-content">
            <div className="web-notification-text">
              <h3 className="web-notification-title">
                {resolveHandlebars(content.subject)} <span className="web-notification-dot">·</span> now
              </h3>
              <p className="web-notification-message">{resolveHandlebars(content.body)}</p>
            </div>

            <div className="web-notification-meta">
              <IconChevronUp size={14} />
            </div>
          </div>
        </div>
      </div>

      <div className="web-notification-additional">
        {!isRecommender && content.imageUrl && (
          <div
            style={{ backgroundImage: `url(${resolveHandlebars(content.imageUrl)})` }}
            className="web-notification-image"
          ></div>
        )}
        {!isRecommender && content.btnText && (
          <div className="web-notification-actions">
            <button className="web-notification-options-button">{resolveHandlebars(content.btnText)}</button>
          </div>
        )}
      </div>
    </div>
  );

  const IOSNotification = () => (
    <div className="web-notification ios-notification">
      <div className="web-notification-main">
        <div className="web-notification-icon">
          <img src={iosAppLogo} alt="App Logo" className="web-notification-chrome-icon" />
        </div>

        <div className="web-notification-body">
          <div className="web-notification-content">
            <div className="web-notification-text">
              <h3 className="web-notification-title">{resolveHandlebars(content.subject)}</h3>
              <p className="web-notification-message">{resolveHandlebars(content.body)}</p>
            </div>

            <div className="web-notification-meta">
              <span className="web-notification-time">now</span>

              {content.imageUrl && (
                <div
                  style={{ backgroundImage: `url(${resolveHandlebars(content.imageUrl)})` }}
                  className="web-notification-image"
                ></div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="preview-container">
      <div className="device-container">
        {platform === 'web' && (
          <div className="web-mockup">
            <div className="browser-chrome">
              <div className="traffic-lights">
                <div className="traffic-light red"></div>
                <div className="traffic-light yellow"></div>
                <div className="traffic-light green"></div>
              </div>
              <div className="address-bar">https://example.com</div>
            </div>
            <div className="webpage-content">
              <WebNotification />
            </div>
          </div>
        )}

        {platform === 'android' && (
          <div className="phone-mockup">
            <div className="android-screen">
              <div className="android-background"></div>
              <AndroidNotification />
            </div>
          </div>
        )}

        {platform === 'ios' && (
          <div className="phone-mockup phone-mockup--ios">
            <div className="ios-screen">
              <div className="ios-background"></div>
              <IOSNotification />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PushNotificationPreview;
